import React from 'react';

// Yellow warning triangle with center exclamation — matches the sidebar
// "recommended fields incomplete" indicator.
export function WarningTriangle({ size = 20, title }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 22" fill="none" style={{ flexShrink: 0 }} aria-label={title}>
      <title>{title}</title>
      <path d="M12 0L24 22H0L12 0Z" fill="#F5BD1F" />
      <ellipse cx="12" cy="18" rx="1.5" ry="1.5" fill="#333" />
      <path d="M12 7C12.9 7 13.2 7.5 13 9L12.5 15.5C12.4 16.2 11.6 16.2 11.5 15.5L11 9C10.8 7.5 11.1 7 12 7Z" fill="#333" />
    </svg>
  );
}

// Red exclamation icon — matches the sidebar "required fields incomplete" indicator.
export function RequiredExclamation({ size = 13, title = 'Required field missing' }) {
  return (
    <i
      className="fas fa-exclamation"
      title={title}
      aria-label={title}
      style={{ color: '#DC2626', fontSize: `${size}px`, flexShrink: 0 }}
    />
  );
}
